module.exports = __webpack_public_path__ + "img/bk_19_02.66df1fbe.png";